import React, {useState} from "react";
import {Link, useHistory, useLocation} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import UIDatePicker from "components/datepicker";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from 'utils/CommonUtil';
import UI from "components/UI";
import codeDataStore from "common/codedata/store/CodeDataStore";
import UIUtils from "../../../../utils/UIUtils";
import UISelect from "../../../../components/selectbox/UISelect";
import TbComFile from "domain/main/com/file/TbComFile";

function ContentsContainer() {

	const location = useLocation();
	const receivedData = (location.state as any)?.data;
	const history = useHistory();

	const [yearList, setYearList] = React.useState<any[]>([{value : new Date().getFullYear()+'', nm : new Date().getFullYear()+'년'}]);
	const [year,setYear] = useState(new Date().getFullYear()+'');
	const [title,setTitle] = useState('');
	const [cont,setCont] = useState('');
	const [bizCd,setBizCd] = useState('');
	const [tskAnnYyyy,setTskAnnYyyy] = useState(new Date().getFullYear()+'');

	const serverUrl = 'http://dev.fund.win-win.or.kr/';

	React.useEffect(() => {
		//필요한 공통코드 로딩.
		codeDataStore.read(
			"cfms.portalBizCdList"
		).then(() => {
			console.log("cfms.portalBizCdList", codeDataStore.get("cfms.portalBizCdList"))
		});

		initCall();

	},[])

	function initCall(){
		let start = new Date().getFullYear() - 10;
		let end = new Date().getFullYear() + 10;
		let newYearList = [];
		for(let i = start; i <= end; i++){
			// @ts-ignore
			newYearList.push({value : i+'', nm : i+'년'})
		}
		setYearList(newYearList);
	}

	//파일정보 선언
	const [corpLogoFileValue] = useState(new TbComFile());
	const [bizLicFileValue] = useState(new TbComFile());
	const [fileValue] = useState(new TbComFile());

	const [uploadComp, setUploadComp] = useState(false);
	const [fileInfoList, setFileInfoList] = React.useState<any[]>([]);

	//파일업로드
	const [uploadId, setUploadId] = React.useState("");

	//파일업로드
    const onCreationComplete = function (uploadID: string) {
        setUploadId(uploadID);
    }

	//파일업로드 완료
	const onUploadComplete = () => {
        const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId);
        const arrayNew = dataArray.newFile;
        const arrayDel = dataArray.deleteFile;
	    console.log("arrayNew " ,JSON.stringify(arrayNew));

		let fileInfos : {
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
		}[] = [];

		let fileInfo : {
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
		};

		//파일등록 정보
		arrayNew?.map((item, index) => {
			if(item.status =="complete"){
				fileInfo = {
					ORGINL_FILE_NM:item.originalName,
					STRE_FILE_NM:item.uploadName,
					FILE_SIZE:item.size,
					STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
					FILE_EXTSN:item.extension,
				}

				fileInfos.push(fileInfo);
			}

			console.log("fileInfos : "+JSON.stringify(fileInfos));
		})

		setFileInfoList(fileInfos);
		setUploadComp(true);
    }

	async function onFileUpload()  {
		if(uploadId){
			await window["RAONKUPLOAD"].Transfer(uploadId);
		}
	}

	React.useEffect(() => {
		if(uploadComp){
			onClickSave(uploadComp);
		}
	},[uploadComp])

	const alertModal = async () => {
		const value = await UIUtils.alert(<>
			필수 입력이 완료되지 않았습니다.<br/>
			다시 확인해 주세요.
		</>);
	}

	async function chkValid(){

		if(title == ''){
			alertModal();
			return false;
		}

		if(cont == ''){
			alertModal();
			return false;
		}
		if(cont == '<p><br></p>'){
			alertModal();
			return false;
		}

		if(year == ''){
			alertModal();
			return false;
		}
		if(bizCd == ''){
			alertModal();
			return false;
		}

		return true;


	}

	//사용자 등록 저장
	async function onClickSave(chk) {
		if(await chkValid()){
			if(chk){
				setUploadComp(false);
				let param = {
					TSK_ANN_TITLE:title
					,TSK_ANN_CONT:cont
					,TSK_ANN_YYYY:year
					,BIZ_CD:bizCd
					,FILE_INFO_LIST:fileInfoList
				}

				const response:any = await CommonUtil.execute({
					url:"adm_1302",
					data: param
				})

				//let result =response.PERSION_ID;
				if (!response.COMMON_HEAD.ERROR) {
					UIUtils.alert("저장되었습니다.");
					//리스트 페이지로 이동
					let dataToSend = {};
					// 다른 페이지로 이동하면서 데이터 전달
					history.push({
						pathname: './adm1300',
						state: { data: dataToSend }
					});


				}
			}else{
				if(await UIUtils.confirm('저장하시겠습니까?')){
					onFileUpload();
				}
			}
		}




	};

	//페이지 건수별로 보기
	const handleSelect = (e) => {
		if(e.target.name === 'year'){
			setYear(e.target.value);
		}
	};

	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<ul className="fww-brd">
					<li><Link to="/admin/">홈</Link></li>
					<li><Link to="#">관리자페이지</Link></li>
					<li><Link to="#">기금관리</Link></li>
					<li><Link to="#">과제관리</Link></li>
					<li><Link to="#">과제신청안내관리</Link></li>
				</ul>
				<main className="fww-main">
					<h1 className="tx tx-hd2">과제 신청 안내 등록</h1>
					<form className="fo fo-col2" name="" action="" method="">
						<div className="inner">
							<div className="fo-item fo-m-1-3 req">
								<p className="fo-key">제목</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} placeholder={'제목을 입력하세요.'} value={title} valueChanged={(value) => setTitle(value)} />
								</div>
							</div>
							<div className="fo-item req">
								<p className="fo-key">사업구분</p>
								<div className="fo-value">
									<div className="sl sl-md w100p">
										<UISelect
											value={bizCd}
											valueChanged={(value) => setBizCd(String(value))}
											codeData={codeDataStore.get("cfms.portalBizCdList")}
											firstName={"sel"}
										/>
									</div>
								</div>
							</div>
							<div className="fo-item req">
								<p className="fo-key">과제신청안내년도</p>
								<div className="fo-value">
									<div className="sl sl-md w120">
										<select name="year" id="year" value={year} onChange={(handleSelect)}>
											{yearList.map((year, idx) => (
												<option value={year.value}>{year.nm}</option>
											))}
										</select>
									</div>
								</div>
							</div>
							<div className="fo-item fo-m-1-3 req">
								<p className="fo-key">내용</p>
								<div className="fo-value">
									<div className='w100p'>
										<UI.SunEditor value={cont} valueChanged={(value) => setCont(value)} />
									</div>
								</div>
							</div>							
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">첨부파일</p>
								<div className="fo-value">
									<div className='w100p'>
										<UI.FileUpload
                            				onCreationComplete={onCreationComplete}
                            				onUploadComplete={onUploadComplete}
                            				attrs={{
                                				MaxTotalFileCount: "1",
                                				ExtensionAllowOrLimit: "1",
                                				Width:"100%",
                                				ImgPreView: "1",
                                				Views: "thumbs"
                            				}}
                            			/>
									</div>
								</div>
							</div>							

						</div>
					</form>

					<div className="hz-root hz-right hz-gap5 mb10">
						<Button color="pri-o" size="sm" onClick={() => onClickSave(false)}>저장</Button>
						<Button color="gray-o" size="sm" ><Link to="adm1300">목록</Link></Button>
					</div>
				</main>
			</div>
		</PageContainer>
	);
}
export default ContentsContainer;